import React from 'react'
import { BoxBody } from '../../ui/box'
import { Row, Col } from '../../ui/grid'
import Memory from '../../helper/memory'
import Percent from '../../helper/percent'
import MilliSeconds from '../../helper/milliseconds'
import { FlamegraphNode, TraceMetric } from '../../domain/Trace'
import { TraceDetailsStacktrace } from '../tracedetails/TraceDetailsStacktrace'

interface Props {
    traceTotals: TraceMetric
    node: FlamegraphNode
    isAggregatedTrace: boolean
    sectionBelowTitle?: React.ReactNode
}

export class FrameSummary extends React.PureComponent<Props> {
    public render = () => {
        const { node, traceTotals, isAggregatedTrace, sectionBelowTitle } = this.props
        const metricColumns = isAggregatedTrace ? 3 : 2
        const metricColumnWidth = metricColumns === 2 ? 6 : 4

        return (
            <>
                {sectionBelowTitle}
                <BoxBody>
                    <div className="tw-font-size-16 tw-mb-8">
                        <Row>
                            <Col width={metricColumnWidth}>
                                {isAggregatedTrace ? <small>Average Call Count</small> : <small>Call Count</small>}
                                <br />
                                {node.stats.ct}
                            </Col>
                            <Col width={metricColumnWidth}>
                                {isAggregatedTrace ? <small>Average Duration</small> : <small>Duration</small>}
                                <br />
                                <MilliSeconds value={node.values.wt} />
                                &nbsp; (<Percent value={traceTotals.wt > 0 ? node.values.wt / traceTotals.wt : 0} />)
                            </Col>
                            {node.values.mc > 0 && isAggregatedTrace ? (
                                <Col width={metricColumnWidth}>
                                    <small>Average Memory</small>
                                    <br />
                                    <Memory value={node.values.mc} />
                                    &nbsp; (<Percent value={traceTotals.mc > 0 ? node.values.mc / traceTotals.mc : 0} />)
                                </Col>
                            ) : null}
                        </Row>
                        {isAggregatedTrace && node.stack && node.stack.length > 0 ? <TraceDetailsStacktrace stack={node.stack} /> : null}
                    </div>
                </BoxBody>
            </>
        )
    }
}
